<article class="row">
    <section class="col-lg-8 col-md-10 col-sm-12 text-center titulares">
        <h1 class="titulo-discreto"><small class="">Webinar:</small> "{{ titulo }}"</h1>
        <h2 class="text-left">La transmisión comienza el {{ fecha }} a las {{ hora }}</h2>
    </section>
</article>

<article class="row" [ngClass]=" {'nolobby': !lobbyuse, 'lobby': lobbyuse } ">
    <section class="col-lg-8 col-md-8 col-sm-12 offset-lg-2 offset-md-2">
        <aside class="video-control">
            <iframe [src]="urllive | domseguro" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
        </aside>
    </section>

</article>

<article class="row align-items-center">
    <section class="col-lg-10 offset-lg-1 col-md-8 offset-md-2 col-sm-12">
        <div class="card card-live-date">
            <div class="card-header alive" [ngClass]=" {'nolive': !ready, 'alive': ready } ">
                Estás es la sala de espera: <b>{{ situacion }}</b> 
            </div>
            <div class="card-body">
                <blockquote class="blockquote mb-0">
                    <p class="text-xl-start">Al comenzar la transmisión en vivo, si deseas hacer comentarios que los participantes de este webinar puedan leer en tiempo real, da clic en el botón de youtube (en la esquina inferior derecha del marco del video) para abrir esta red social en una nueva pestaña.</p>
                </blockquote>
            </div>
        </div>
    </section>
</article>

